const f = {
  color: {
    default: "#304ddbff",
    hover: "#263aadff",
    active: "#1c2674ff"
  }
};
export {
  f as link
};
